module["exports"] = [
  "England",
  "Scotland",
  "Wales",
  "Northern Ireland"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_GB/address/default_country.js
 ** module id = 402
 ** module chunks = 0
 **/